import { ENV } from '../../config'
import { map } from '../../utils/maths'
import { CAMERA_MODE } from './CamerasHandler';

// Dynamic imports for development mode only
let Tweakpane;
let ImportExportPlugin
;(async () => {
    if (ENV.IS_DEV) {
        Tweakpane = await import('tweakpane')
        ImportExportPlugin = await import('tweakpane-plugin-import-export')
        EssentialsPlugin = await import('@tweakpane/plugin-essentials')
    }
})()

function threeColorToObject(threeColor) {
    const {r,g,b} = threeColor;
    return {r,g,b};
}


export default {
    initTweakPane() {
        if(!ENV.IS_DEV) {
            return
        }

        this.pane = new Tweakpane.Pane();
        this.pane.registerPlugin(ImportExportPlugin)
        this.pane.registerPlugin(EssentialsPlugin);

        this.pane.hidden = true;
        this.pane.containerElem_.style.position = 'fixed';
        this.pane.containerElem_.style.zIndex = 9999;

        this.onKeyUp = (e) => {
            if(e.ctrlKey && e.key == 'Escape') {
                this.pane.hidden = !this.pane.hidden;   
                if(this.pane.hidden) {
                    // this.setCameraMode(CAMERA_MODE.DEFAULT)
                    this.wrapper.remove(this.debugSun)                    
                } else {
                    // this.setCameraMode(CAMERA_MODE.PANEL)
                    this.wrapper.add(this.debugSun)
                    this.stopAutoDate = true
                }
            }
        }
        document.addEventListener('keyup', this.onKeyUp)

        this.paneParams = {             
            scene: {
                camera: {
                    mode: this.cameraMode+'',
                    position: {x: 0,y: 0,z: 0}, // refreshed by render
                    target: {x: 0,y: 0,z: 0}, // refreshed by render,
                    autoRotateSpeed: this.controls.autoRotateSpeed,
                    dampingFactor: this.controls.dampingFactor,
                },
                sun: {
                    x: map(this.sunSpherical.theta,-Math.PI,Math.PI,-1,1),
                    y: map(this.sunSpherical.phi,0,Math.PI,-1,1),
                },
                date: {                    
                    month: map(this.dayOfTheYear,0,365,0,12),
                    hour: map(this.secondOfTheDay,0,86400,0,24),
                }
            },
            colors: {
                uAtmosphereDayColor: threeColorToObject(this.earth.globe.material.uniforms.uAtmosphereDayColor.value),
                uAtmosphereTwilightColor: threeColorToObject(this.earth.globe.material.uniforms.uAtmosphereTwilightColor.value),
                uManLightsColor: threeColorToObject(this.earth.globe.material.uniforms.uManLightsColor.value),
                uReflectionColor: threeColorToObject(this.earth.globe.material.uniforms.uReflectionColor.value),
            },
            earth: this.earth.globe.material.uniforms,
            atmosphere: this.earth.atmosphere.material.uniforms 
        }

        let scene =  this.pane.addFolder({
          title: 'Scene',
        });

        const onDateChange = (e) => {
            this.ignoreDate = false            

            this.dayOfTheYear = map(this.paneParams.scene.date.month, 0,12,0,365);
            this.secondOfTheDay = map(this.paneParams.scene.date.hour, 0,24,0,86400);            
        }
        scene.addBinding(this.paneParams.scene.date, 'month', { min: 0, max: 12 }).on('change', onDateChange)
        scene.addBinding(this.paneParams.scene.date, 'hour', { min: 0, max: 24 }).on('change', onDateChange)

        scene.addBinding(this.paneParams.scene, 'sun', { 
            label: 'Sun', 
            x: { min: -1, max: 1, step: 0.01 },
            y: { min: -1, max: 1, step: 0.01 }
        }).on('change', (e) => {
            this.ignoreDate = true
            
            this.sunSpherical.theta = map(this.paneParams.scene.sun.x,-1,1,-Math.PI,Math.PI)
            this.sunSpherical.phi = map(this.paneParams.scene.sun.y,-1,1,0,Math.PI)
        })

        let camera = scene.addFolder({ 
            title: 'Camera'
        })

        const modes = [
            [CAMERA_MODE.DEFAULT, CAMERA_MODE.SPLASH],
            [CAMERA_MODE.MODAL, CAMERA_MODE.PANEL]
          ]
        camera.addBinding(this.paneParams.scene.camera, 'mode', {
            view: 'radiogrid',
            groupName: 'mode', 
            size: [2, 2],
            cells: (x, y) => ({
              title: modes[y][x],
              value: modes[y][x]
            }),
            label: 'mode',
        }).on('change', (ev) => {             
            this.setCameraMode(this.paneParams.scene.camera.mode); 
        });

        // camera.addMonitor(this.paneParams.scene.camera, 'position', {
        //     multiline: true,
        //     interval: 1000,
        // });
        camera.addBinding(this.paneParams.scene.camera, 'position').on('change', (e) => {
            this.camera.position.set(e.value.x,e.value.y,e.value.z)
        })
        camera.addBinding(this.paneParams.scene.camera, 'target').on('change', (e) => {
            this.controls.target.set(e.value.x,e.value.y,e.value.z)
        })        
        camera.addBinding(this.offsetCamera, 'target', { label: "offset" }); 

        camera.addBinding(this.controls, 'autoRotateSpeed', { label: 'Autorotate' })
        camera.addBinding(this.controls, 'dampingFactor', { label: 'Damping', min:0.001,max:0.1})


        let earth =  this.pane.addFolder({
          title: 'Earth',
        });        

        earth.addBinding(this.paneParams.earth.uCSB, 'value', { label: 'Con.Sat.Bri.', x: { min: 0, max: 2, step: 0.01 }, y: { min: 0, max: 2, step: 0.01 }, z: { min: 0, max: 2, step: 0.01 } }).on('change', (e) => {
            this.paneParams.atmosphere.uCSB.value = e.value;
        })

        const earthAtm = earth.addFolder({
            title: 'Atmosphere' 
        }) 

        earthAtm.addBinding(this.paneParams.colors, 'uAtmosphereDayColor', { label: 'Day Color', color: {type: 'float'} }).on('change', (e) => {
            this.paneParams.earth.uAtmosphereDayColor.value = e.value
            this.paneParams.atmosphere.uAtmosphereDayColor.value = e.value 
        })
        earthAtm.addBinding(this.paneParams.colors, 'uAtmosphereTwilightColor', { label: 'Twilight color', color: {type: 'float'} }).on('change', (e) => {
            this.paneParams.earth.uAtmosphereTwilightColor.value = e.value
            this.paneParams.atmosphere.uAtmosphereTwilightColor.value = e.value
        })        

        const night = earth.addFolder({
            title: 'Night'
        })

        night.addBinding(this.paneParams.colors, 'uManLightsColor', { label: 'Lights', color: {type: 'float'} }).on('change', (e) => {
            this.paneParams.earth.uManLightsColor.value = e.value
        });
        night.addBinding(this.paneParams.earth.uNightDarkness, 'value', { label: 'Darkness', min: 0.0, max: 1.0 });        

        const clouds = earth.addFolder({
            title: 'Clouds'
        })        

        clouds.addBinding(this.paneParams.earth.uCloudsCut, 'value', { label: 'Mask', min: 0.001, max: 1.0 });
        clouds.addBinding(this.paneParams.earth.uCloudsOpacity, 'value', { label: 'Opacity', min: 0.0, max: 1.0 });
        clouds.addBinding(this.paneParams.earth.uCloudsNightOpacity, 'value', { label: 'Night opacity', min: 0.0, max: 0.1 });

        const reflection = earth.addFolder({
            title: 'Water reflection',
            expanded: false
        })

        reflection.addBinding(this.paneParams.earth.uReflectionPow, 'value', { label: 'Precision', min: 1, max: 32, step: 1 });
        reflection.addBinding(this.paneParams.colors, 'uReflectionColor', { label: 'Color', color: {type: 'float'} }).on('change', (e) => {
            this.paneParams.earth.uReflectionColor.value = e.value
        });

        // IMPORT / EXPORT
        this.pane.addBlade({ view: 'import-export' })
    },

    updateTweakPane() {
        if(!this.pane) return

        this.paneParams.scene.camera.position.x = this.camera.position.x;
        this.paneParams.scene.camera.position.y = this.camera.position.y;
        this.paneParams.scene.camera.position.z = this.camera.position.z;              

        this.paneParams.scene.camera.mode = this.cameraMode

        this.pane?.refresh?.()
    },
    
    destroyTweakPane() {
        document.removeEventListener('keyup', this.onKeyUp)
        this.pane?.dispose?.();
    }
}
